var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutHelpCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91663 6.3C8.17496 3.3 9.71663 2.075 13.0916 2.075H13.2C16.925 2.075 18.4166 3.56666 18.4166 7.29166V12.725C18.4166 16.45 16.925 17.9417 13.2 17.9417H13.0916C9.74163 17.9417 8.19996 16.7333 7.92496 13.7833",
    stroke: "#F2F4F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 10H3.51672",
    stroke: "#F2F4F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37504 7.20833L2.58337 10L5.37504 12.7917",
    stroke: "#F2F4F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutHelpCenter);
export default __webpack_public_path__ + "static/media/logout-help-center.5692a6fb5a0594454bfa8890d0c55777.svg";
export { ForwardRef as ReactComponent };